import {
	createApiRef,
	DiscoveryApi,
	FetchApi,
} from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import {
	TeamMetadata,
	TeamMetadataEntity,
} from '@internal/plugin-team-metadata-common';

export interface TeamMetadataApi {
	getTeamMetadata(teamName: string): Promise<TeamMetadataEntity | undefined>;
	updateTeamMetadata(
		teamName: string,
		metadata: TeamMetadata,
	): Promise<TeamMetadataEntity>;
}

export const teamMetadataApiRef = createApiRef<TeamMetadataApi>({
	id: 'plugin.team-metadata.service',
});

export class TeamMetadataClient implements TeamMetadataApi {
	constructor(
		private readonly options: {
			discoveryApi: DiscoveryApi;
			fetchApi: FetchApi;
		},
	) {}

	async getTeamMetadata(
		teamName: string,
	): Promise<TeamMetadataEntity | undefined> {
		const response = await this.options.fetchApi.fetch(
			await this.teamUrl(teamName),
		);
		if (response.status === 404) {
			return undefined;
		}
		if (!response.ok) {
			throw await ResponseError.fromResponse(response);
		}
		return response.json();
	}

	async updateTeamMetadata(
		teamName: string,
		metadata: TeamMetadata,
	): Promise<TeamMetadataEntity> {
		const response = await this.options.fetchApi.fetch(
			await this.teamUrl(teamName),
			{
				method: 'PUT',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(metadata),
			},
		);
		if (!response.ok) {
			throw await ResponseError.fromResponse(response);
		}
		return response.json();
	}

	private async teamUrl(teamName: string): Promise<string> {
		const baseUrl = await this.options.discoveryApi.getBaseUrl('team-metadata');
		return `${baseUrl}/teams/${encodeURIComponent(teamName)}`;
	}
}
